exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".credits {\n  text-align: left;\n  color: #3c3c3c;\n  opacity: 1;\n  font-size: 0.8vw;\n  clear: both;\n  padding-bottom: 1.3vh;\n  z-index: 100;\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  background-color: white;\n}\n.credits .text {\n  text-decoration: underline;\n  cursor: pointer;\n}\n.credits .text:hover {\n  text-decoration: none;\n  color: #006f88;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();